import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://127.0.0.1:5000';

// Create axios instance with base URL
const api = axios.create({
  baseURL: API_URL,
  withCredentials: true, // Important for cookie-based authentication
  headers: {
    'Content-Type': 'application/json',
  }
});

// Request interceptor
api.interceptors.request.use(
  (config) => {
    // No need to add auth token - using session cookies instead
    console.log(`Making ${config.method?.toUpperCase()} request to ${config.url}`);
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for handling errors
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    console.log('API Error intercepted:', {
      url: error.config?.url,
      method: error.config?.method,
      status: error.response?.status,
      statusText: error.response?.statusText
    });

    // Handle authentication errors (401 Unauthorized or 403 Forbidden)
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      console.log('Authentication error detected');

      // Only redirect to login if we're not already on an auth-related page
      // This prevents redirect loops and allows users to access pages that don't require auth
      const isAuthPage = window.location.pathname.includes('/login') ||
                         window.location.pathname.includes('/register') ||
                         window.location.pathname.includes('/confirm-email') ||
                         window.location.pathname.includes('/forgot-password') ||
                         window.location.pathname.includes('/password-reset');

      if (!isAuthPage) {
        console.log('Redirecting to login page');
        // Use a slight delay to allow logs to be seen in console
        setTimeout(() => {
          window.location.href = '/login';
        }, 100);
      } else {
        console.log('Not redirecting to login because we are on an auth page:', window.location.pathname);
      }
    }
    return Promise.reject(error);
  }
);

// Helper function to handle form data
export const createFormData = (data) => {
  const formData = new FormData();

  Object.keys(data).forEach(key => {
    if (data[key] !== undefined && data[key] !== null) {
      formData.append(key, data[key]);
    }
  });

  return formData;
};

export default api;
